import { useMutation, useQueryClient } from "@tanstack/react-query";

import { JobStatusEnum } from "../../enum/jobEnums";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { updateJobStatus } from "../services/job.services";

export const useUpdateJobStatus = (options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ jobId, status }: { jobId: number; status: JobStatusEnum }) => updateJobStatus(jobId, status),
    onSuccess: (_, variables) => {
      // Invalidate all job list queries (with any filters) by using the base key pattern
      queryClient.invalidateQueries({ queryKey: [...GO_HIRE_QUERY_KEYS.all, "jobs-list"] });
      // Invalidate specific job details
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.jobDetails(variables.jobId) });
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
